export default __webpack_public_path__ + "static/media/690.7a6af88f.png";